export default __webpack_public_path__ + "static/media/header-background.7366dba7.svg";